module.exports = __webpack_public_path__ + "static/media/RightToCorrectForm_QCPP_FR.2d234936.pdf";